var React = require('react');

function MyAccountIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.615 16.5a8 8 0 1 0-13.23 0 9.996 9.996 0 0 1 3.159-1.887 5 5 0 1 1 6.912 0 9.995 9.995 0 0 1 3.159 1.887zm1.386 1.5A9.956 9.956 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10a9.962 9.962 0 0 0 6.615-2.5c.511-.451.976-.954 1.386-1.5zm-2.71 0A7.97 7.97 0 0 0 12 16a7.97 7.97 0 0 0-5.292 2A7.97 7.97 0 0 0 12 20a7.97 7.97 0 0 0 5.292-2zM12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","fill":"#fff"}));
}

MyAccountIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MyAccountIcon;

MyAccountIcon.default = MyAccountIcon;
